var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarLogoSm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Nav-tabs"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#E3EAEF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Value"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.148 26.3519L23.6275 22.8321C24.6479 21.6071 25.1567 20.0358 25.0481 18.4451C24.9395 16.8545 24.2218 15.3669 23.0444 14.2919C21.867 13.2169 20.3204 12.6373 18.7265 12.6735C17.1325 12.7097 15.6139 13.359 14.4865 14.4864C13.3592 15.6138 12.7098 17.1324 12.6736 18.7263C12.6374 20.3203 13.2171 21.8668 14.292 23.0443C15.367 24.2217 16.8546 24.9394 18.4452 25.048C20.0359 25.1566 21.6072 24.6477 22.8322 23.6273L26.3521 27.1479C26.4043 27.2001 26.4664 27.2416 26.5347 27.2699C26.6029 27.2982 26.6761 27.3127 26.75 27.3127C26.8239 27.3127 26.8971 27.2982 26.9654 27.2699C27.0337 27.2416 27.0957 27.2001 27.148 27.1479C27.2003 27.0956 27.2417 27.0336 27.27 26.9653C27.2983 26.897 27.3129 26.8238 27.3129 26.7499C27.3129 26.676 27.2983 26.6028 27.27 26.5345C27.2417 26.4663 27.2003 26.4042 27.148 26.3519ZM13.8125 18.8749C13.8125 17.8736 14.1094 16.8949 14.6657 16.0623C15.222 15.2298 16.0127 14.5809 16.9377 14.1978C17.8628 13.8146 18.8807 13.7144 19.8627 13.9097C20.8447 14.105 21.7468 14.5872 22.4548 15.2952C23.1628 16.0032 23.6449 16.9052 23.8403 17.8873C24.0356 18.8693 23.9353 19.8872 23.5522 20.8123C23.169 21.7373 22.5201 22.528 21.6876 23.0842C20.8551 23.6405 19.8763 23.9374 18.875 23.9374C17.5328 23.9359 16.246 23.4021 15.297 22.453C14.3479 21.5039 13.814 20.2171 13.8125 18.8749Z",
    fill: "black"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarLogoSm);
export default __webpack_public_path__ + "static/media/sidebar-logo-sm.159a9adaa8793450102cd08a45dec8a5.svg";
export { ForwardRef as ReactComponent };